import { toast } from "./toastStore";

// Re-exported so components can grab both from one place:
//   import { useToast, toast } from "../components/common/useToast";
export { toast } from "./toastStore";

/**
 * Hook access to the toast API, for ergonomic in-component use:
 *
 *   const toast = useToast();
 *   toast.success(t("saved"));
 *   toast.error(t("something_went_wrong"));
 *
 * `toast` is a stable module singleton, so this returns the same reference every
 * render (safe in deps arrays, no memoisation needed). Non-React code can import
 * `toast` directly instead.
 */
export function useToast() {
  return toast;
}
